import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-background-50 text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-100/70 rounded-2xl">
          <i className="ri-emotion-sad-line text-primary-600 text-2xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mt-6 font-heading">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">该页面不存在或尚未生成</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-all no-underline whitespace-nowrap"
        >
          <i className="ri-home-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}